// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10EgT","importantInfo":"styles_importantInfo__3MSF9"};